import { render, staticRenderFns } from "./FichaDesenvolvimentoMensal.vue?vue&type=template&id=5ca011d4"
import script from "./FichaDesenvolvimentoMensal.vue?vue&type=script&lang=js"
export * from "./FichaDesenvolvimentoMensal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports